import { Component, OnInit } from '@angular/core';
import {
  StepType,
  RegistrationStepQuery,
  RegistrationStepService,
  LoggingService,
  ErrorStateService,
  AddressModel
} from '@fgb/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Regex } from 'src/app/shared/utilities/regex';

@Component({
  selector: 'fgb-registration-shipping-address',
  templateUrl: './registration-shipping-address.component.html',
  styleUrls: ['./registration-shipping-address.component.scss']
})
export class RegistrationShippingAddressComponent implements OnInit {
  readonly stepType = StepType.ShippingAddress;
  hasSubmitted: boolean = false;

  shippingForm: FormGroup = this.formBuilder.group({
    FirstName: ['', Validators.required],
    Surname: ['', Validators.required],
    EmailAddress: ['', Validators.pattern(Regex.email)],
    HomeNumber: ['', Validators.required],
    Street: ['', Validators.required],
    Town: ['', Validators.required],
    County: ['', Validators.required],
    Postcode: ['', [Validators.required, Validators.pattern(Regex.postCode)]],
    Country: ['', Validators.required]
  });

  constructor(
    private registrationStepQuery: RegistrationStepQuery,
    private registrationStepService: RegistrationStepService,
    private logService: LoggingService,
    public errorService: ErrorStateService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    const step = this.registrationStepQuery.getStep(this.stepType);
    if (!step) {
      this.logService.warning('No step data found in the store for step', this.stepType);
      return;
    }

    this._prefillExistingStepData(step.Data as AddressModel);
  }

  submitStep() {
    this.hasSubmitted = true;

    if (!this.shippingForm.valid) {
      this.errorService.clearErrors();
      this.errorService.addError('Some fields are invalid.');
      return;
    }

    this.registrationStepService.submitRegistrationStepData(this.stepType, this.shippingForm.value as AddressModel).toPromise();
  }

  /** Prefills the given step data into the form control values. */
  private _prefillExistingStepData(stepData?: AddressModel) {
    if (stepData) {
      for (const [key, value] of Object.entries(stepData)) {
        const control = this.shippingForm.get(key);
        if (control) {
          control.setValue(value);
        }
      }
    }
  }
}
